import React from 'react';

/**
 * Company UPI / Personal QR — managed on company profile (Add/Edit Company).
 * Same checkbox event shape as user AgentInternalFlags (type + checked).
 */
const CompanyPersonalUpiFields = ({ formData, onChange, errors = {} }) => {
  const enabled = Boolean(formData?.personal_upi_qr_enabled);
  const upiId = formData?.company_upi_id || '';

  const handleToggle = (e) => {
    onChange({
      target: {
        name: 'personal_upi_qr_enabled',
        type: 'checkbox',
        checked: e.target.checked,
      },
    });
  };

  const handleUpiChange = (e) => {
    onChange({
      target: {
        name: 'company_upi_id',
        value: e.target.value,
      },
    });
  };

  return (
    <div>
      <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
        Company UPI / Personal QR
      </h3>
      <p className="text-xs sm:text-sm text-gray-500 mb-3">
        Optional company UPI ID QR on booking. Money goes to company — not remitted by the agent.
        Payment Gateway (Razorpay) takes priority when configured. Turn this off (and Payment Gateway)
        for classic agent-own Cash/UPI remittance.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-3xl">
        <label className="flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50 cursor-pointer">
          <input
            type="checkbox"
            name="personal_upi_qr_enabled"
            checked={enabled}
            onChange={handleToggle}
            className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded shrink-0"
          />
          <span>
            <span className="block text-sm font-medium text-gray-800">
              Enable personal company UPI QR
            </span>
            <span className="block text-xs text-gray-500 mt-0.5">
              When ON and UPI is selected on Add Shipment, show this QR before create.
              Agent taps Payment received after the customer pays.
            </span>
          </span>
        </label>

        <div className={`p-3 rounded-xl border border-gray-200 bg-gray-50 ${enabled ? '' : 'opacity-60'}`}>
          <label
            className="block text-sm font-medium text-gray-800 mb-1"
            htmlFor="company_upi_id"
          >
            Company UPI ID
          </label>
          <input
            id="company_upi_id"
            type="text"
            name="company_upi_id"
            value={upiId}
            onChange={handleUpiChange}
            placeholder="company@okaxis"
            disabled={!enabled}
            className={`w-full px-3 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm bg-white ${
              errors.company_upi_id ? 'border-red-400' : 'border-gray-300'
            }`}
            autoComplete="off"
          />
          <p className="text-xs text-gray-500 mt-1">
            Required when enabled. Cash bookings still remit as today.
          </p>
          {errors.company_upi_id ? (
            <p className="text-xs text-red-600 mt-1">{errors.company_upi_id}</p>
          ) : null}
        </div>
      </div>

      <label className="mt-3 flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50 cursor-pointer max-w-3xl">
        <input
          type="checkbox"
          name="branch_upi_qr_enabled"
          checked={Boolean(formData?.branch_upi_qr_enabled)}
          onChange={(e) => onChange({
            target: {
              name: 'branch_upi_qr_enabled',
              type: 'checkbox',
              checked: e.target.checked,
            },
          })}
          className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded shrink-0"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">
            Enable branch UPI QR
          </span>
          <span className="block text-xs text-gray-500 mt-0.5">
            When on, a location hub with a Branch UPI ID collects UPI on that account.
            The amount still settles. Hubs without a Branch UPI ID keep Razorpay or company UPI.
          </span>
        </span>
      </label>
    </div>
  );
};

export default CompanyPersonalUpiFields;
